import { onMounted, onUnmounted, readonly, ref } from 'vue';

const showCreatedDate = ref(false);

let consumerCount = 0;

const isShiftNine = (event: KeyboardEvent): boolean => event.shiftKey && event.code === 'Digit9';

const handleKeyDown = (event: KeyboardEvent): void => {
	if (isShiftNine(event)) {
		showCreatedDate.value = true;
	}
};

const handleKeyUp = (event: KeyboardEvent): void => {
	if (event.key === 'Shift' || event.code === 'Digit9' || !event.shiftKey) {
		showCreatedDate.value = false;
	}
};

const handleReset = (): void => {
  showCreatedDate.value = false;
};

export function useDebugDateKey() {
	onMounted(() => {
		if (consumerCount === 0) {
			window.addEventListener('keydown', handleKeyDown);
			window.addEventListener('keyup', handleKeyUp);
			window.addEventListener('blur', handleReset);
		}
		consumerCount += 1;
	});

	onUnmounted(() => {
		consumerCount -= 1;
		if (consumerCount === 0) {
			window.removeEventListener('keydown', handleKeyDown);
			window.removeEventListener('keyup', handleKeyUp);
			window.removeEventListener('blur', handleReset);
			showCreatedDate.value = false;
		}
	});

	return {
		showCreatedDate: readonly(showCreatedDate)
	};
}
